import axios from 'axios'
import { Notify } from 'vant';
import qs from 'qs'
import api from "@/api/api";
// create an axios instance
const service = axios.create({
  baseURL: api.apiConfig.baseUrl, // api 的 base_url
  timeout: 10000 // request timeout,
})

// request interceptor
service.interceptors.request.use(
  config => {
    // Do something before request is sent
    // if (store.getters.token) {
    //   // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
    //   config.headers['X-Token'] = getToken()
    // }
     // 发送请求之前做的事
     //config.data = qs.stringify(config.data);
    // const token =  localStorage.getItem("token");
    // config.headers['token'] = token;
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  //response => response,
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过 xmlhttprequest 来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  response => {
    const res = response.data
    if (res.code === 0) {
      //Notify({ type: 'success', message: '成功' });



      // // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
      // if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
      //   // 请自行在引入 MessageBox
      //   // import { Message, MessageBox } from 'element-ui'
      //   MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
      //     confirmButtonText: '重新登录',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(() => {
      //     store.dispatch('FedLogOut').then(() => {
      //       location.reload() // 为了重新实例化vue-router对象 避免bug
      //     })
      //   })
      // }
      return response.data
     // return Promise.reject(res.msg)
    }else if(res.code === 1){
      Notify({ type: 'warning', message: res.msg });
      return Promise.reject(res.msg)
    }else if(res.code === 1000){
      localStorage.removeItem("token")


        return Promise.reject('error')
    } else {
      return response.data
    }
  },
  error => {
    console.log('err' + error) // for debug
    Notify({ type: 'warning', message: '失败' });
    return Promise.reject(error)
  }
)

const postWay =  function  post(url, data, callback) {
    data = {
      ...data,

    };
    // data=JSON.stringify(data)
    return service.post(url, data).then(response => {
      callback(response);
    });
 
}

const getWay =  function  get(url, data, callback) {
  //data = qs.stringify(data);
  return service.get(url,{'params':data} ).then(response => {
    callback(response);
  });

}

const putWay =  function  put(url, data, callback) {
  data = qs.stringify(data);
  return service.put(url,data ).then(response => {
    callback(response);
  });

}
service["putWay"]=putWay
service["postWay"]=postWay
service["getWay"]=getWay
export default service



// WEBPACK FOOTER //
// ./src/api/request.js